import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '../../plantilla/header/header.component';
import { FooterComponent } from '../../plantilla/footer/footer.component';
import { ButtonAtomComponent } from '@ls-commons/components';
import { ImageModule } from 'primeng/image';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { DividerModule } from 'primeng/divider';
import { CartService } from '../../cart/cart.service';
import { Product } from '../../cart/cart.model';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { SectionService } from '@ls-commons/sections';
import { SectionsResponse } from '@lemonsolutions/models';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError, map } from 'rxjs';
import { APIService } from 'src/app/services/api.service';
import { InsuranceService } from 'src/app/dashboard/insurance/insurance/insurance.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-insurance-detail',
  standalone: true,
  imports: [
    CommonModule,
    HeaderComponent,
    FooterComponent,
    ButtonAtomComponent,
    ImageModule,
    RouterModule,
    DividerModule,
    ButtonModule,
    DialogModule,
  ],
  templateUrl: './insurance-detail-modal.component.html',
  styleUrl: './insurance-detail-modal.component.scss',
})
export class InsuranceDetailModalComponent implements OnInit {
  cartService = inject(CartService);
  sectionService = inject(SectionService);
  apiService = inject(APIService);
  item: any | undefined;
  item_id!: number;
  visible: boolean = false;
  policySectionData: any = {};

  http = inject(HttpClient);
  insuranceService = inject(InsuranceService);

  constructor(
    // private activatedRoute: ActivatedRoute,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {
    // this.activatedRoute.queryParams.subscribe(params => {
    //   this.item_id = params['productId'];
    // });
    this.item_id = this.config.data.element_id;
    // console.log(this.config.data);

    // const { element_id } = this.config.data;
  }

  ngOnInit(): void {
    if (this.item_id) {
      // this.item = this.cartService.productList.find(
      //   element => element.productId == this.item_id
      // );
      // console.log(this.item_id);
      this.insuranceService.getInsurance(this.item_id).subscribe(response => {
        this.item = response;
        // console.log(response);
      });
      // console.log(this.item_id);
    }

    // At this moment we only need first element of policy section data
    this.apiService.getSections(8, 'es').subscribe(response => {
      this.policySectionData = response?.data[0];
    });
  }
  handleError(err: any, arg1: string): any {
    throw new Error('Method not implemented.');
  }

  addToCart() {
    this.item && this.cartService.addProduct(this.item, 1);
  }

  showDialog() {
    this.visible = true;
  }
}
